<script>
import Layout from "@/router/layouts/auth";
import { mapState, mapActions } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import Languages from "@/components/widgets/languages";
import Password from "@/components/widgets/input-password";

export default {
  locales: {
    pt: {
      'Username': 'Usuário',
      'Password': 'Senha',
      'Username is required.': 'O nome de usuário é obrigatório.',
      'Sign in': 'Entrar',
      'Forgot your password?': 'Esqueceu sua senha?',
      "Don't have an account?": 'Não possui uma conta?',
      'Sign up': 'Cadastre-se',
      'TECHNOLOGY BY': 'TECNOLOGIA POR',
      'You have successfully logged in.': 'Login realizado com sucesso.',
      'The username and/or password are incorrect.': 'O usuário e/ou senha estão incorretos.',
    },
    es: {
      'Username': 'Nombre de Usuario',
      'Password': 'Contraseña',
      'Username is required.': 'El nombre de usuario es obligatorio.',
      'Sign in': 'Iniciar sesión',
      'Forgot your password?': '¿Olvidaste tu contraseña?',
      "Don't have an account?": '¿No tienes una cuenta?',
      'Sign up': 'Regístrate',
      'TECHNOLOGY BY': 'TECNOLOGÍA POR',
      'You have successfully logged in.': 'Has iniciado sesión con éxito.',
      'The username and/or password are incorrect.': 'El usuario y/o la contraseña son incorrectos.',
    },
  },
  components: {
    Layout,
    Languages,
    Password,
  },
  data() {
    return {
      language: "en",

      email: "",
      password: "",
      loading: false,
      submitted: false,

      user: {
        name: "",
        email: "",
        avatar: "",
      },
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
  },
  validations: {
    email: { required },
    password: { required, minLength: minLength(6) },
  },
  created() {
    this.logout();
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { email, password } = this;
        if (email && password) {
          this.alert.type = "";
          this.alert.message = "";
          this.loading = true;
          this.$v.$reset();
          this.login({ email, password });
        }
      }
    },
    clearUser() {
      this.email = "";
      this.user.email = "";
    },
  },
  mounted() {
    if (this.$store.state.account.user) {
      this.email = this.$store.state.account.user.email;
      this.user.email = this.$store.state.account.user.email;
    }
  },
  watch: {
    "alert.type": function (alert) {
      if (alert == "alert-danger") {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 text-center">
          <router-link class="align-middle d-flex justify-content-center align-items-center" tag="a" to="/">
            <img class="w-100" style="max-width: 250px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-5">
          <div class="border rounded py-3 mb-4">
            <h5 class="m-0 font-size-14 font-weight-normal text-uppercase text-center">
              Centro de Distribuição
            </h5>
          </div>
          <b-form @submit.prevent="handleSubmit">
            <div v-if="alert.message" :class="'alert ' + alert.type">
              {{ t(alert.message) }}
            </div>
            <b-form-group label="Email" label-for="email">
              <b-form-input v-model="email" type="text" :class="{ 'is-invalid': submitted && $v.email.$error }"></b-form-input>
              <div v-if="submitted && !$v.email.required" class="invalid-feedback">
                O email é obrigatório.
              </div>
            </b-form-group>
            <b-form-group label="Senha" label-for="password">
              <Password v-model="password" :v="$v.password"></Password>
            </b-form-group>
            <div class="mt-4">
              <b-button :disabled="loading == true" type="submit" variant="default" class="btn-lg btn-block">
                Entrar
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
              </b-button>
            </div>
            <div class="mt-4 text-center">
              <router-link tag="a" to="/password-forgot" class="text-muted">
                {{ t('Forgot your password?') }}
              </router-link>
            </div>
          </b-form>
          <div class="mt-2 text-center">
            <Languages class="d-none" type="dropup"></Languages>
            <p class="mt-5 font-size-12 text-uppercase text-muted">
              <a class="text-muted font-size-11" target="_blank" href="https://m2n.com.br/?utm_source=nexteev.com&utm_medium=link&utm_campaign=logo">
                {{ t('TECHNOLOGY BY') }}<br />
                <img alt="M2N" style="width: 50px" src="@/assets/images/logo-m2n.svg" />
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="flex-fill login-image d-none d-lg-block">
      </div>
    </div>
  </Layout>
</template>